import type { LpPhaseDef, LpPhaseKey, LpPresetDef, LpPresetKey, LpStatusDef, LpStatusKey } from './types';

export const GROWTH_LANDING_PAGES_META = {
  eyebrow: 'Google Ads · Landing Pages',
  titleLead: 'Landing',
  titleAccent: 'pages',
  description:
    'Each campaign has one landing page URL. ELVA tests 3-4 variants of that page against real traffic — exploration → validation → winner — continuously optimizing for the highest conversion rate.',
} as const;

export const LP_PRESETS: Record<LpPresetKey, LpPresetDef> = {
  code_red: { label: 'Code Red', tone: 'terra' },
  high_ticket: { label: 'High-Ticket Authority', tone: 'lav' },
  transactional: { label: 'Procedure-Specific', tone: 'info' },
  new_local: { label: 'New to Area', tone: 'success' },
  offer_funnel: { label: 'Offer Funnel', tone: 'gold' },
  anxiety: { label: 'High-Anxiety / Sedation', tone: 'lav' },
  family: { label: 'Family & Pediatric', tone: 'success' },
};

export const LP_STATUS_META: Record<LpStatusKey, LpStatusDef> = {
  pending_approval: { label: 'Pending Approval', tone: 'gold' },
  live: { label: 'Live', tone: 'success' },
  paused: { label: 'Paused', tone: 'neutral' },
  archived: { label: 'Archived', tone: 'neutral' },
};

export const LP_PHASE_META: Record<LpPhaseKey, LpPhaseDef> = {
  exploration: {
    label: 'Exploration',
    tone: 'info',
    pct: 20,
    description: 'Testing 4 variants — split evenly to find winners',
  },
  validation: {
    label: 'Validation',
    tone: 'lav',
    pct: 30,
    description: 'Testing top 2 variants — confirming the leader',
  },
  exploitation: {
    label: 'Exploitation',
    tone: 'success',
    pct: 50,
    description: 'Running the winning variant at 100% of traffic',
  },
  converged: {
    label: 'Converged',
    tone: 'success',
    pct: 50,
    description: 'Winner has been running stable — next refresh test in 52 days',
  },
};

export const LP_PHASE_ORDER: readonly LpPhaseKey[] = ['exploration', 'validation', 'exploitation'] as const;
